import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, getUTCTimeStamp, getUTCTimeStampp, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw {
      message: 'NO Data.',
      code: 'SERVER_ERROR_500',
    }
  }
  if (isStatusOK(data) && data?.data?.responseStatus?.code === '000') {
    console.log('data at try block in responseParser getLRNMappingBCApi', data)
    console.log('data in responseParser getLRNMappingBCApi', data)
    return data.data.responseObject
  } else {
    console.log('data at catch block in responseParser getLRNMappingAPI', data.data)
    console.log('data at catch block in responseParser getLRNMappingBCApi', data.data)
    throw getNetworkResponseError(data?.data)
  }
}

export const getLRNMappingBCApi = (tokens: any, body: { mobileNumber: string; categoryId: string | number }) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  config.headers['x-channelId'] = RootStore.agent.session.CHANNEL_ID || ''
  config.headers['x-channel-user-id'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-intercept-gateway'] = 'SERVICE/JPB'

  const requestBody = {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: RootStore.agent.session.CHANNEL_ID || '',
      channelId: RootStore.agent.session.CHANNEL_ID || '',
      returnUrl: null,
      callbackUrl: null,
    },
    category: {
      id: String(body.categoryId) || '',
    },
    customerDetails: {
      prepaidMobile: {
        number: body.mobileNumber,
      },
      jpbUserId: RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '',
      agentId: RootStore.agent.agentInfo.agentUserLoginId || '',
    },
  }

  const request: Request<{}> = {
    apiPath: APIEndPoints.getLRNMapping,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Akanksha see what data we are sending to getLRNMappingBCApi response parser')
      console.log('requestBody in getLRNMappingBCApi', requestBody)
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
